import { useCallback } from 'react'
import { API_HOST_NAME } from '../constants.js'
import { useAuthentication } from '../../../../../contexts/AuthenticationContext.jsx'
import fetchJSON from '../../../fetchJSON.js'
import toUrlSearchParams from '../../../toUrlSearchParams.js'
import { compact } from 'lodash'

const useNodeStatisticsResource = (teamId, nodeId) => {
  const { getValidToken } = useAuthentication()

  const getStatistics = useCallback((metric, params = {}) => {
    const queryString = toUrlSearchParams(params).toString()
    const baseUrl = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/nodes/${nodeId}/statistics/${metric}`
    const fullUrl = compact([baseUrl, queryString]).join('?')

    return getValidToken()
      .then((accessToken) => fetchJSON(fullUrl, 'GET', {
        headers: {
          Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
        },
      }))
  }, [teamId, nodeId, getValidToken])

  return { getStatistics }
}

export default useNodeStatisticsResource
